<!--  Garantia -->
<div [ngClass]="{ 'warranty-column': flex == 'column', 'warranty-row': flex == 'row' }" class="pl-3">
  <div class="w-100 mb-4">
    <label>Determine o tempo de garantia*</label>
    <div class="row d-flex align-items-center justify-content-between mx-0">
      <div class="position-relative w-100">
        <ng-container>
          <input
            type="text"
            #dp="bsDatepicker"
            placeholder="Selecione a data"
            class="form-control"
            bsDatepicker
            autocomplete="off"
            (bsValueChange)="progressWarranty($event)"
            [ngModel]="dateService.TransformDate({ warranty: warranty }, 'get')"
            [bsConfig]="{
              isAnimated: true,
              containerClass: 'theme-dark-blue',
              dateInputFormat: 'DD-MM-YYYY',
              showWeekNumbers: false
            }"
          />
          <i
            class="far fa-calendar position-absolute"
            (click)="dp.show()"
            style="right: 16px; top: 35%; cursor: text"
          ></i>
        </ng-container>
      </div>
    </div>
  </div>

  <app-warranty-view
    class="d-flex align-items-end"
    [warranty]="warranty"
    [warrantyActive]="warrantyActive"
    [warrantyCurrent]="warrantyCurrent"
    [warrantyEnd]="warrantyEnd"
    [warrantyLastUpdate]="warrantyLastUpdate"
    [warrantyProgress]="warrantyProgress"
    [flex]="flex"
    [createdAt]="createdAt"
  ></app-warranty-view>
</div>
<!--  Garantia -->
